import { connect } from 'react-redux'
import cn from 'clsx'

// Components
import { Button, Section, Spinner } from '@tracklib/kit'
import ArticleItem from 'components/articles/item'
import Video from 'components/base/video'

// Types
import { CmsPage, State } from 'types'

import styles from './featuredarticlesblock.css'

type FeaturedGridBlockProps = {
  value: {
    exclude_article: number
    heading: string
    video_url: string
    video_title: string
    video_image: number
    length: string
    owner: string
  }
  // mapStateToProps
  articles: Array<CmsPage>
}

const FeaturedGridBlock = ({
  articles,
  value: { heading, video_url, video_title, video_image, length, owner },
}: FeaturedGridBlockProps): JSX.Element => {
  return (
    <Section
      extraPad
      className={styles.wrapper}
      heading={heading}
      linkUrl={heading && '/blog/all/'}
      linkText="See All"
      datatesting="featured_gridblock"
    >
      {articles.length ? (
        <>
          {articles
            .filter((i, index) => index < 5)
            .map(article => {
              return <ArticleItem className={styles.item} key={article.id} article={article} isBig />
            })}
          <Video
            src={video_url}
            title={video_title}
            image={video_image}
            length={length}
            owner={owner}
            className={cn(styles.item, styles.video)}
          />
          <Button to="/blog/all" className={styles.button}>
            See all blog posts
          </Button>
        </>
      ) : (
        <Spinner minHeight={500} />
      )}
    </Section>
  )
}

const mapStateToProps = (state: State, { value: { exclude_article } }: FeaturedGridBlockProps): JSX.Element => {
  const { pageSummaries } = state.entities
  const pageSummaryList = Object.keys(pageSummaries).map(id => pageSummaries[id])
  return {
    articles: pageSummaryList
      .filter(i => i.meta.type === 'cms.ArticlePage')
      .filter(i => i.id !== exclude_article)
      .sort((a, b) => new Date(b.meta.first_published_at) - new Date(a.meta.first_published_at)),
  }
}
export default connect(mapStateToProps)(FeaturedGridBlock)
